import React from 'react';
import Input from './Input';

/**
 * Cleanly handles formatting of decimal-based numeric input. When the user clicks on the control,
 * editing is enabled; when the user blurs, the decimal is formatted.
 *
 * Added: RLC 11/2/20
 */
export class NumericInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = { editing: false };
    }

    onChange(event) {
        event.persist();
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    // Updated formatting function
    toFormatted = (value, fractionDigits) => {
        if (value === '' || value === null || value === undefined) return '';

        let num;
        // If it's a string, attempt to parse it
        if (typeof value === 'string') {
            num = parseFloat(value);
            if (isNaN(num)) return '';
        } else if (typeof value === 'number') {
            num = value;
        } else {
            // If value is not a string or number, return empty string
            return '';
        }

        // If wholeNumber is true, round the number
        if (this.props.wholeNumber) {
            return Math.round(num).toString();
        }
        if (fractionDigits == 3) {
            const input = Number(value);
            const s = input.toFixed(3);
            const third = s.split('.')[1]?.[2] ?? '0';
            fractionDigits = third === '0' ? 2 : 3;
        }
        // Otherwise, format to 2 decimal places
        return num.toFixed(fractionDigits);
    };

    // Toggle editing mode using a simple toggle
    toggleEditing = () => this.setState((prevState) => ({ editing: !prevState.editing }));

    render() {
        const {
            value, min, max, fractionDigits, ...restProps
        } = this.props;

        return (
            <>
                {this.state.editing ? (
                    <Input
                        type="number"
                        min={min ?? -99999}
                        max={max ?? 999999}
                        value={this.props.value ?? ''}
                        onChange={this.onChange.bind(this)}
                        onBlur={this.toggleEditing.bind(this)}
                        displayMaxLength={false}
                        onKeyDown={(e) => {
                            if (this.props.preventNegative) {
                                if (
                                    !(
                                        (e.keyCode > 95 && e.keyCode < 106) ||
                                        (e.keyCode > 47 && e.keyCode < 58) ||
                                        e.keyCode === 8
                                    )
                                ) {
                                    return false;
                                }
                            }
                        }}
                        {...restProps}
                    />
                ) : (
                    <Input
                        type="number"
                        min={min ?? -99999}
                        max={max ?? 999999}
                        value={this.toFormatted(value, this.props.fractionDigits ?? 2) ?? ''}
                        onChange={this.onChange.bind(this)}
                        onFocus={this.toggleEditing.bind(this)}
                        displayMaxLength={false}
                        {...restProps}
                    />
                )}
            </>
        );
    }
}

export default NumericInput;